module.exports = __webpack_public_path__ + "static/media/react complete guide.e7c64a33.pdf";